import PropTypes from 'prop-types';
import React from 'react';
import { NamespaceConsumer } from '@ux/namespace-component';

/**
 * Render the title of the tooltip.
 *
 * @param {Object} props Component properties.
 * @returns {ReactElement} Div containing title.
 * @private
 */
export default class TooltipTitle extends NamespaceConsumer {

  render() {
    const { children } = this.props;
    return <div className={ this.namespace('tooltip-title') }>
      { children }
    </div>;
  }
}

/**
 * Property types definition.
 *
 * @enum {Object} propTypes
 * @private
 */
TooltipTitle.propTypes = {
  children: PropTypes.node
};
